import "reflect-metadata";
import {inject, injectable} from "inversify";
import {PanelAdmRepository} from "@dropDesk/domain/repositories/panel_adm/panel_adm.repository";

@injectable()
export class AllowSubscriptionUpgradePanelUseCase {
    private _repository: PanelAdmRepository;

    constructor(@inject(PanelAdmRepository) repository: PanelAdmRepository) {
        this._repository = repository;
    }

    public call(idCompany: string, idSubscription: string): Promise<void> {
        return this._repository.allowSubscriptionUpgrade(idCompany, idSubscription);
    }
}

